export const MCP_TOOL_METADATA_KEY = 'mcp:tool';
export const MCP_RESOURCE_METADATA_KEY = 'mcp:resource';
export const MCP_RESOURCE_TEMPLATE_METADATA_KEY = 'mcp:resource-template';
export const MCP_PROMPT_METADATA_KEY = 'mcp:prompt';
